
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import Testable from '@/mixins/Testable'
import { namespace } from 'vuex-class'

const dateFormat = 'YYYY-MM-DD'
const Auth = namespace('auth')

@Component({
	model: {
		prop: 'value',
		event: 'change'
	}
})
export default class Datepicker extends Mixins(Testable) {
	@Prop({
		type: Object,
		default: { start: moment().format(dateFormat), end: '' },
		validator: (value) => {
			return !!(
				Object.prototype.hasOwnProperty.call(value, 'start') &&
				Object.prototype.hasOwnProperty.call(value, 'end')
			)
		}
	})
	value!: { start: string; end: string }

	@Prop({
		type: Boolean,
		default: false
	})
	range!: boolean

	@Auth.Getter('firstDayOfWeek')
	firstDayOfWeek!: string

	startDate: string = ''
	endDate: string = ''

	datepickerDate: string = ''
	centerDate: string = ''
	datepickerModal: boolean = false

	dateFormat: string = dateFormat

	created() {
		this.centerDate = moment().format(dateFormat)

		if (this.value.start) {
			this.centerDate = this.value.start
		}
	}

	@Watch('value', { immediate: true, deep: true })
	setDatepickerFromValue(newValue: { start: string; end: string }) {
		this.startDate = newValue.start
		this.endDate = newValue.end
	}

	@Watch('datepickerDate')
	datepickerDateChange(newValue: string) {
		this.startDate = newValue
		this.endDate = ''

		this.centerDate = newValue

		this.emit()
	}

	setDateRange(date) {
		const formattedDate = date.format(this.dateFormat)

		if (formattedDate === this.startDate) {
			this.startDate = ''
			this.endDate = ''

			return this.emit()
		}

		if (!this.range || !this.startDate) {
			this.startDate = formattedDate

			return this.emit()
		}

		if (this.startDate && this.endDate) {
			this.startDate = formattedDate
			this.endDate = ''

			return this.emit()
		}

		if (this.startDate && !this.endDate) {
			this.endDate = formattedDate

			return this.emit()
		}
	}

	emit() {
		const start = moment(this.startDate)
		const end = moment(this.endDate)

		if (end < start) {
			this.startDate = end.format(dateFormat)
			this.endDate = start.format(dateFormat)
		}

		this.$emit('change', {
			start: this.startDate,
			end: this.endDate
		})
	}

	dateIsActive(date) {
		const formattedDate = date.format(this.dateFormat)

		return (
			date.isBetween(this.startDate, this.endDate) ||
			date.isBetween(this.endDate, this.startDate) ||
			this.startDate.startsWith(formattedDate) ||
			this.endDate.startsWith(formattedDate)
		)
	}

	get selectableDates(): Array<Moment> {
		const numberOfDaysBefore = 0
		const numberOfDaysAfter = 8

		const dates: Array<Moment> = []

		// Add dates before the selected date from the datepicker
		for (let i = numberOfDaysBefore; i > 0; i--) {
			const date = moment(this.centerDate)
			dates.push(date.subtract(i, 'days'))
		}

		// Add the selected date from the datepicker
		dates.push(moment(this.centerDate))

		// Add dates after the selected date from the datepicker
		for (let i = 0; i < numberOfDaysAfter; i++) {
			const date = moment(this.centerDate)
			dates.push(date.add(i + 1, 'days'))
		}

		return dates
	}
}
